var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('cui-acl',{attrs:{"roles":['underDevelopment'],"redirect":""}},[_c('h4',[_vm._v("Lønnskjøringer")]),_c('payrollsList'),_c('a-divider'),_c('newPayroll')],1)}
var staticRenderFns = []

export { render, staticRenderFns }